import produce from 'immer'

import {
  FETCH_ORDER_REQUESTED,
  FETCH_ORDER_SUCCEEDED,
  FETCH_ORDER_FAILED,
} from './actionTypes'

export const defaultOrder = {
  loading:true,
  order: {
    description: '',
    budget: null,
    due_datetime: null,
    photos: [],
    skill: { name: '' },
    city: { name: '' }
  }
}

const initialState = defaultOrder
/* eslint no-param-reassign: "error" */
const orderReducer = produce((draft = initialState, action) => {
  switch (action.type) {
    case FETCH_ORDER_REQUESTED:
      draft.loading = true
      return draft

    case FETCH_ORDER_SUCCEEDED:
      draft.order = action.payload.order
      draft.loading = false
      return draft

    case FETCH_ORDER_FAILED:
      draft.error = action.payload.error
      draft.loading = true
      return draft

    default:
      return draft
  }
})

export default orderReducer



// WEBPACK FOOTER //
// ./src/store/order/reducer.js